<template>
<div class="player">
    <iframe        
        :style="this.iframe.style"
        :src="this.iframe.src"
        allowfullscreen="true"
        ref="iframeContent"
        rameborder="0"
        height="100%"
        width="100%"
    ></iframe>
</div>
</template>

<script>
export default {
    name: 'ClassPlayer',
    props: {
        video: String,
        progress: Number,
    },
    data() {
        return {
            domain: window.axios.PLAYER_DOMAIN,
            iframe: {
                src: null,
                style: null,
                wrapperStyle: null,
                loaded: false,
            },
            sending: false,
            skipped: false,
        };
    },
    watch: {
        video() {
            this.urlVideo();
        },
    },
    methods: {
        urlVideo() {
            this.iframe = {
                ...this.iframe,
                src: `${this.domain}/${this.video}`,
            };
        },
        updateProgress(res) {
            if (res.origin !== this.domain) return;
            const lessonId = this.parents.filter(parent => parent.type === 'lesson').id;
            const result = JSON.parse(res.data);
            if (result.eventName === 'jmvplayerout-screencast' && !this.sending) {
                this.sending = true;
                window.axios
                    .post(`/api/app/lesson/content/log/${lessonId}`, {
                        attributes: {
                            duration: result.duration,
                            currentTime: result.currentTime,
                        },
                    })
                    .then(() => {
                        this.iframe = {};
                        window.location.reload();
                    })
                    .catch(err => console.error(err));
            }
            this.$emit('info', result);
        },
        syncPlayerProgress() {
            this.$refs.iframeContent.contentWindow.postMessage(JSON.stringify({
                public_event: 'jmvplayer-sync',
                screencast: '',
            }), '*');
            window.addEventListener('message', (event) => {this.updateProgress(event)}, false);
        },
        waitLoading() {
            setTimeout(() => {}, 2000);
        },
        getScreencastInfo() {
            return window.axios
                .get('/api/app/lesson/content/screencast-info')
                .then(res => res.data)
                .catch(err => console.error(err));
        },
        async screencastPost() {
            const screencastInfo = await this.getScreencastInfo();

            this.$refs.iframeContent.contentWindow.postMessage(JSON.stringify({
                public_event: 'jmvplayer-screencast',
                screencast: screencastInfo,
            }), '*');
        },
        load() {
            this.iframe.loaded = true;
            this.screencastPost();
            setTimeout(this.syncPlayerProgress, 2000);
        },
        currentProgress(currentTime, duration) {
            return Math.round((currentTime / duration) * 100);
        },

        timeToSkip(duration) {
            return (this.progress * duration) / 100;
        },
        skip(res) {
            if (res.origin !== this.domain) return;

            const result = JSON.parse(res.data);

            if (!this.skipped &&
                this.progress >= this.currentProgress(result.currentTime, result.duration)) {
                this.$refs.iframeContent.contentWindow.postMessage(
                    JSON.stringify({ public_event: 'jmvplayer-jump', jump: this.timeToSkip(result.duration) }),
                    '*',
                );

                this.skipped = true;
            }
        },
        skipToLastTime() {
            window.addEventListener('message', this.skip, false);
        },
    },
    async mounted() {
        this.urlVideo();
        if (this.progress && this.progress < 100) {
            this.skipToLastTime();
        }
        this.load();
    },
};
</script>

<style>
.player {
    position: relative;
    padding-top: 56%;
}
.player iframe {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    border: none;
}
@media print {
    .player {
        display: none;  /* hide whole page */
    }
}
</style>
